import { BrandInsightsInstanceContext, BrandInsightsPageContext, ChatContextItem, ChatContextType } from "@trinity/chat";
import { buildDefaultChatContext } from "@trinity/chat-components/components/Chat.State/state.initial-state";

type BuildDefaultChatContext = {
  contextItems: ChatContextItem[];
  groupId: number;
  pathname: string;
};

export const buildInitialChatContext = ({
  contextItems, groupId, pathname,
}: BuildDefaultChatContext): BrandInsightsPageContext.Item => {
  // Hackathon agent default — wires the global widget on the project
  // shell (`/projects/11/*`) to the same agent the segmentation builder
  // uses via ChatInterfaceNative. Scoped to project 11 only for now.
  // The segment profile route (/projects/11/segments/:id) is EXCLUDED
  // because that page's Synthetic Audience tab renders DigitalTwinChat
  // with a segment-specific persona context that would otherwise be
  // clobbered.
  if (
    /^\/projects\/11(\/|$)/.test(pathname) &&
    !/^\/projects\/11\/segments\/[^/]+/.test(pathname)
  ) {
    const hackathonAgent = contextItems.find((f) =>
      f.agent?.identifier?.startsWith('hackathon-agent')
    );
    if (hackathonAgent) {
      return {
        type: ChatContextType.Agent,
        data: hackathonAgent,
        metadata: {},
      } as BrandInsightsInstanceContext.ItemWithMetadata;
    }
  }

  //setting default chat context for widget on project page for demo account
  const clinicalMetricsAgent = contextItems.find(f => f.identifier === '1287759c4d3e4f2fb1079d0a83411251');
  if (clinicalMetricsAgent && pathname.includes('/project') && groupId === 229) {
    return {
      type: ChatContextType.Agent,
      data: clinicalMetricsAgent,
      metadata: {},
    } as BrandInsightsInstanceContext.ItemWithMetadata;
  }
  //setting default chat context for widget on project page for demo account
  const caseLevelAgent = contextItems.find(f => f.identifier === '9a1d7c9421d742beb89f9a26afe46082');
  if (caseLevelAgent && pathname.includes('/project') && groupId === 218) {
    return {
      type: ChatContextType.Agent,
      data: caseLevelAgent,
      metadata: {},
    } as BrandInsightsInstanceContext.ItemWithMetadata;
  }
  if (pathname.includes('/folders')) {
    return buildDefaultChatContext(ChatContextType.Global);
  }
  const profileAgent = contextItems.find(f => f.agent.identifier === 'kol-profile');
  const everythingAgent = contextItems.find(f => f.agent.identifier === 'global');

  if (profileAgent) {
    return buildDefaultChatContext(ChatContextType.KolProfile);
  }

  if (everythingAgent) {
    return buildDefaultChatContext(ChatContextType.Global);
  }

  const defaultContextItem = contextItems[0];

  if (defaultContextItem) {
    return {
      type: ChatContextType.Agent,
      data: defaultContextItem,
      metadata: {},
    } as BrandInsightsInstanceContext.ItemWithMetadata;
  }

  return {
    type: ChatContextType.Global,
  };

  // throw new Error('No valid chat context could be determined');
};